import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PublicImage } from '@/components/common/PublicImage/PublicImage';
import {
  COUNTDOWN_TICK_MS,
  EXTENSION_INSTALL_REDIRECT_SECONDS,
} from '@/constants/external/extension';
import { browserUtils } from '@/utils';
import styles from './ExtensionInstallRedirect.module.scss';

export const ExtensionInstallRedirect: React.FC = () => {
  const { t } = useTranslation();
  const [secondsLeft, setSecondsLeft] = useState(
    EXTENSION_INSTALL_REDIRECT_SECONDS
  );

  useEffect(() => {
    if (secondsLeft === 0) {
      window.location.href = browserUtils.directUserToStore();
      return;
    }
    const timeoutId = setTimeout(
      () => setSecondsLeft(previous => previous - 1),
      COUNTDOWN_TICK_MS
    );
    return () => clearTimeout(timeoutId);
  }, [secondsLeft]);

  return (
    <div className={styles.container}>
      <PublicImage
        src="/images/extension/system-redirect.svg"
        alt="Extension installation illustration"
        className={styles.image}
      />
      <h5 className={styles.title}>{t('extensionRequired.title')}</h5>
      <p className={styles.subtitle}>
        {t('extensionRequired.subtitle', { seconds: secondsLeft })}
      </p>
    </div>
  );
};
